import React, { lazy, Suspense } from 'react';
import './website/assets/css/style.css'
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './website/pages/Home';
import './admin/assets/style.css'
import { Navigate } from 'react-router-dom';
import AdminDashboard from './admin/pages/AdminDashboard';
import DetailsPage from './website/pages/shopNowPages/DetailsPage';
import Wishlist from './website/pages/shopNowPages/Wishlist';
import Login from './website/pages/shopNowPages/myAccount/Login';
import Register from './website/pages/shopNowPages/myAccount/Register';
import SubCategroy from './website/pages/shopNowPages/SubCategroy';
import ForgotPassword from './website/pages/shopNowPages/myAccount/ForgotPassword';
import AddressBook from './website/pages/shopNowPages/myAccount/AddressBook';
import OrderHistory from './website/pages/shopNowPages/myAccount/OrderHistory';
import NotFound from './website/component/NotFound';
import CheckOut from './website/pages/shopNowPages/CheckOut';
import CartItems from './website/pages/shopNowPages/CartItems';
import Layout from './website/layout/Layout';
import MyProfile from './website/pages/shopNowPages/myAccount/MyProfile';
import ChangePwd from './website/pages/shopNowPages/myAccount/ChangePwd';
import OrderDetails from './website/pages/shopNowPages/myAccount/OrderDetails';
import PrivateRoute from './website/utils/authMiddleware';

import LoginForm from "./admin/pages/Login";
import SideBar from "./admin/layout/SideBar";
import AdminCategory from "./admin/pages/AdminCategory";
import AdminSubCategory from "./admin/pages/AdminSubCategory";
import AdminAttributes from "./admin/pages/AdminAttributes";
import AdminSubCategoryAttributeGroup from "./admin/pages/AdminSubCategoryAttributeGroup";
import AdminProducts from "./admin/pages/AdminProducts";
import AdminOrders from "./admin/pages/AdminOrders";
import AdminOrderDetails from "./admin/pages/AdminOrderDetails";
import AdminContact from './admin/pages/AdminContact';
import AddProduct from './admin/pages/AddProduct';
import EditProduct from './admin/pages/EditProduct';
// import AdminSize from "./admin/pages/AdminSize";
import AdminGST from "./admin/pages/AdminGST";
import Contact from './website/pages/Contact';
import About from './website/pages/About';

import PaymentFailed from './website/pages/shopNowPages/PaymentFailed';
import PaymentSuccess from './website/pages/shopNowPages/PaymentSuccess';
// import PaymentResult from './website/pages/shopNowPages/PaymentResult'

const AdminLayout = ({ children }) => {
  const isAuthenticated = () => {
    const token = sessionStorage.getItem('sakhi_token_admin');

    return token !== null;
  };
  const PrivateRoute = ({ children }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/admin" />;
    }
    return children;
  };
  return (
    <div>
      <PrivateRoute>
        <SideBar>{children}</SideBar>
      </PrivateRoute>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout><Home /> </Layout>} />
        <Route path='/wishlist' element={<Layout><Wishlist /></Layout>} />
        <Route path='/cart' element={<Layout><CartItems /></Layout>} />
        <Route path='/contact' element={<Layout><Contact /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path='/account/login' element={<Layout><Login /></Layout>} />
        <Route path='/account/register' element={<Layout><Register /></Layout>} />
        <Route path='/account/forgotPwd' element={<Layout><ForgotPassword /></Layout>} />
        <Route path='/account/addressbook' element={<PrivateRoute element={<Layout><AddressBook /></Layout>} />} />
        <Route path='/account/order-history' element={<PrivateRoute element={<Layout><OrderHistory /></Layout>} />} />
        <Route path='/account/change-password' element={<PrivateRoute element={<Layout><ChangePwd /></Layout>} />} />
        <Route path='/account/myprofile' element={<PrivateRoute element={<Layout><MyProfile /></Layout>} />} />
        <Route path='/:category_slug/:subcategory_slug/:product_slug' element={<Layout><DetailsPage /></Layout>} />
        <Route path='/:category_slug/:subcategory_slug' element={<Layout><SubCategroy /></Layout>} />
        <Route path="/:category_slug" element={<Layout><SubCategroy /></Layout>} />
        <Route path="/order/:orderId/:enc" element={<Layout><OrderDetails /></Layout>} />

        {/* <Route path="/payment-result" element={<PaymentResult/>}/>
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/order-failed" element={<OrderFailed />} /> */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/failed" element={<PaymentFailed />} />

        <Route path='/checkout' element={<Layout><CheckOut /></Layout>} />

        <Route path="/admin" element={<LoginForm />} />
        <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/admin/category" element={<AdminLayout><AdminCategory /> </AdminLayout>} />
        <Route path="/admin/sub-category" element={<AdminLayout><AdminSubCategory /></AdminLayout>} />
        <Route path="/admin/attributes" element={<AdminLayout><AdminAttributes /></AdminLayout>} />
        <Route path="/admin/sub-category-attribute-group" element={<AdminLayout><AdminSubCategoryAttributeGroup /></AdminLayout>} />
        <Route path="/admin/products" element={<AdminLayout><AdminProducts /> </AdminLayout>} />
        <Route path="/admin/:order_status/orders" element={<AdminLayout><AdminOrders /> </AdminLayout>} />
        <Route path="/admin/:order_status/orders/:customer_id" element={<AdminLayout><AdminOrders /> </AdminLayout>} />
        <Route path="/admin/order/:cust_order_id/:enc" element={<AdminLayout><AdminOrderDetails /> </AdminLayout>} />
        <Route path='/admin/contact-list' element={<AdminLayout><AdminContact /></AdminLayout>} />
        <Route path='/admin/products/add' element={<AdminLayout><AddProduct /></AdminLayout>} />
        <Route path='/admin/products/edit' element={<AdminLayout><EditProduct /></AdminLayout>} />
        {/* <Route path="/admin/size" element={<AdminLayout><AdminSize /></AdminLayout>} /> */}
        <Route path="/admin/gst" element={<AdminLayout><AdminGST /></AdminLayout>} />
        

        <Route path='/*' element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;